<!--manage-users works!-->
<h3>Manage Users</h3>
<div id="topmost">
  <!-- This div on down is not displayed display:none-->
  <div id="customer-list-pane">
    <!-- for the future: for users as Corporate Admins with multiple customers to switch in place -->
    <div id="customer-grid">
      <kendo-grid #customerGrid [data]="gridView" (selectionChange)="customerSelection($event)" [selectable]="true" [sortable]="{allowUnsort: true,mode:'single'} "
        [sort]="sort" (sortChange)="sortChange($event)">
        <kendo-grid-column field="CustomerID" title="ID" [width]="50">
        </kendo-grid-column>
        <kendo-grid-column field="Name" title="Customer" [width]="200">
        </kendo-grid-column>
        <kendo-grid-column field="UserCount" title="User Count" [width]="120">
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
